import React, { useState, useContext } from 'react';

import UsersContext from '../../contexts/usersContext';

import Participant from './Participant/Participant';
import Filter from '../../components/UI/Filter/Filter';
import Info from '../../components/UI/Info/Info';

import classes from './Participants.module.scss';

const Participants = props => {
    const Users = useContext(UsersContext)[0].participants;

    const [auth, setAuth] = useState(true);
    const [filters, setFilters] = useState({
        section: '',
        participation: ''
    })

    const onFilterChangedHandler = (id, value) => {
        const updatedFilters = {
            ...filters,
            [id]: value
        }
        setFilters(updatedFilters);
    }

    const displayedData = Object.keys(Users)
        .map(key => {
            return {
                key: key,
                data: Users[key]
            }
        })
        .sort((el1, el2) => {
            if (el1.data.lastName < el2.data.lastName) {
                return -1;
            } else {
                return 1;
            }
        })
        .filter(el => {
            let result = true;
            for (let fil in filters) {
                if (filters[fil] !== '') {
                    result = result && el.data[fil] === filters[fil];
                }
            }
            return result;
        })
        .map(el => <Participant
            key={el.key}
            name={`${el.data.firstName} ${el.data.lastName}`}
            affiliation={el.data.affiliation}
            title={el.data.title}
            auth={auth}
            showModal={props.showModal}
            setModalContent={props.setModalContent}
        />)

    let displayedFilters = [];
    if (filters) {
        displayedFilters = Object.keys(filters)
            .map(key => ({
                id: key,
                value: filters[key]
            }))
            .map(el => <Filter
                key={el.id}
                id={el.id}
                filter={el.id}
                changed={onFilterChangedHandler} />
            );
    }

    return <div className={classes.Right}>
        <h1>Participants</h1>
        <Info>Use filters to restrict participants list. Sign in (using data received during registration) to read abstracts and get the MS Teams link.</Info>
        <div className={classes.Filters}>
            {displayedFilters}
        </div>
        <ol>
            {displayedData}
        </ol>
    </div>
}

export default Participants;